import React, { useState } from 'react';
import { Box, Collapse } from '@mui/material';
import { PRES, SPACE, TYPE } from '../chrome';
import { focusVisibleSx, reducedMotionSx } from './focus';

interface PanelSectionProps {
  title: string;
  children: React.ReactNode;
  collapsible?: boolean;
  defaultOpen?: boolean;
}

const PanelSection: React.FC<PanelSectionProps> = ({
  title,
  children,
  collapsible = false,
  defaultOpen = true,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Box sx={{ mb: `${SPACE[5]}px` }}>
      {collapsible ? (
        <Box
          component="button"
          type="button"
          onClick={() => setOpen((current) => !current)}
          aria-expanded={open}
          sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            border: 0,
            bgcolor: 'transparent',
            p: 0,
            mb: 1,
            cursor: 'pointer',
            color: PRES.textSecondary,
            fontFamily: TYPE.ui,
            ...TYPE.section,
            textTransform: 'uppercase',
            ...focusVisibleSx,
            ...reducedMotionSx,
          }}
        >
          <span>{title}</span>
          <Box component="span" sx={{ color: PRES.textTertiary }}>{open ? '–' : '+'}</Box>
        </Box>
      ) : (
        <Box sx={{ color: PRES.textSecondary, fontFamily: TYPE.ui, ...TYPE.section, textTransform: 'uppercase', mb: 1 }}>
          {title}
        </Box>
      )}
      {collapsible ? <Collapse in={open} timeout={160}>{children}</Collapse> : children}
    </Box>
  );
};

export default PanelSection;
